import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-0"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "banner__inner" }
const _hoisted_4 = { class: "banner__content" }
const _hoisted_5 = {
  key: 0,
  class: "banner__slogan"
}
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.title)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", {
          class: "banner",
          style: _normalizeStyle([
        _ctx.backgroundImage
          ? { 'background-image': 'url(' + _ctx.backgroundImage + ')' }
          : null,
      ])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.title) + " " + _toDisplayString(_ctx.name), 1),
                _createElementVNode("div", {
                  class: "banner__contentBG",
                  style: _normalizeStyle([
                _ctx.backgroundColor
                  ? { 'background-color': _ctx.backgroundColor }
                  : null,
              ])
                }, null, 4)
              ]),
              (_ctx.slogan)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: "font-sweetly",
                      innerHTML: _ctx.slogan
                    }, null, 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 4)
      ]))
    : _createCommentVNode("", true)
}